export const TRANSLATIONS_EN = {
    file: {
        sizeError: 'File size exceeded',
        typeError: 'Wrong file type',
        imageTypeError: 'Image type is invalid',
        videoTypeError: 'Video type is invalid'
    }
}